import columns from '../../../../../react-table/helpers/columns';

export default (data) => {
  const {
    TextColumn,
    DateTimeColumn,
  } = columns(data);

  return [
    {
      Header: '',
      columns: [
        new TextColumn('Sender', 'sender'),
        new TextColumn('Receiver', 'receiver'),
        new TextColumn('Sending mailbox', 'sendingMailbox'),
        new TextColumn('Receiving mailbox', 'receivingMailbox'),
        new TextColumn('INTREF', 'intref'),
        new TextColumn('EDI file name', 'ediFileName').withWidth(300),
        new TextColumn('Flat file name', 'flatFileName').withWidth(320),
        new TextColumn('Status', 'status'),
        new DateTimeColumn('On network date', 'onNetworkDate'),
        new DateTimeColumn('Mailbox date', 'mailboxDate'),
        new DateTimeColumn('Pickup date', 'pickUpDate'),
      ],
    },
  ];
};
